import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import {
    clearTrueLayerParams,
    getCurrentPathname,
    getTrueLayerErrorDetail,
    isTrueLayerFailureReturn,
    isTrueLayerSuccessReturn
} from '../../iwRouter/LocationHelper';

export function useTrackOpenBankingCallback() {
    useEffect(() => {
        if (isTrueLayerSuccessReturn()) {
            tracking.ampli.openBankingLinkedSuccessfully({
                url: getCurrentPathname()
            });
        }

        if (isTrueLayerFailureReturn()) {
            const errorDetail = getTrueLayerErrorDetail();
            if (errorDetail === 'access_denied') {
                tracking.ampli.openBankingLinkingCancelled({
                    url: getCurrentPathname()
                });
            } else {
                tracking.ampli.openBankingLinkingFailed({
                    url: getCurrentPathname()
                });
            }
            clearTrueLayerParams();
        }
    }, []);
}
